import React from 'react';
import Pagination from 'partial/components/Pagination';
import Table from 'partial/components/Table';
import { useReportsContext } from 'partial/wrappers/ReportsContext';

const labelClassName = 'whitespace-nowrap';
const contentClassName = 'whitespace-nowrap';

const format = [
  { label: 'DATE OF TRANSACTION', key: 'updated_at' },
  { label: 'ORGANIZATION NAME', key: 'organization_name' },
  { label: 'TYPE', key: 'type' },
  { label: 'DEBIT', key: 'debit' },
  { label: 'CREDIT', key: 'credit' },
  { label: 'BALANCE', key: 'balance' },
  { label: 'STATUS', key: 'status' },
].map((item) => ({
  ...item,
  labelClassName,
  contentClassName,
}));

export default function WalletBalance() {
  const { isLoading, list, meta, setPage } = useReportsContext();

  return (
    <div className="flex flex-col gap-10 min-h-[65vh]">
      <Table isLoading={isLoading} data={list} format={format} />
      {!isLoading && <Pagination value={meta} onChange={setPage} />}
    </div>
  );
}
